import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';

import { MultiSelectFieldProps } from './interface';
import InternalMultiSelectDropdown from './InternalMultiSelectDropdown';
import InternalMultiSelectList from './InternalMultiSelectList';

export const MultiSelectField = (props: MultiSelectFieldProps) => {
  const { name } = props;
  const { control } = useFormContext();

  return (
    <Controller
      control={control}
      name={name}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return props.variant === 'list' ? (
          <InternalMultiSelectList {...props} error={error} onChange={onChange} value={value} />
        ) : (
          <InternalMultiSelectDropdown {...props} error={error} onChange={onChange} value={value} />
        );
      }}
    />
  );
};
